import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "../src/assets/css/style.css";
import "../src/assets/css/default.css";
import "../src/assets/css/custom.css";
import "../src/assets/css/dateRange.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { Provider } from "react-redux";
import store from "./Component/store/Provider";
import {
  CLOSE_LOADER,
  LOADER_OPEN,
} from "./Component/store/dialogue/dialogue.type";
import { baseURL, secretKey } from "./util/config";
import Loader from "./util/Loader";


// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken } from "firebase/messaging";
// const app = initializeApp({
//   apiKey: "AIzaSyCpB2lnYwD6DOCpoWItC_K8gHH0ZeOPmxo",
//   authDomain: "followapp-16669.firebaseapp.com",
//   projectId: "followapp-16669",
//   storageBucket: "followapp-16669.firebasestorage.app",
//   messagingSenderId: "787560649732",
//   appId: "1:787560649732:web:066d58c9ed26c289bf5151",
//   measurementId: "G-GNCL9P7F03"
// });
//  const messaging = getMessaging(app);
//   getToken(messaging, {
//     vapidKey: {
//       "type": "service_account",
//       "project_id": "followapp-16669",
//       "private_key_id": "31bbf1df939d9127b10e120f58276847fcf0b188",
//       "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDXNaVYlQaMP8lD\nzvcHD2JRDd2MGaz8oRdHAQdU3EFobX9LgzleBegpinir24epzLhiKldHifOoHPCX\ndUJ4Sx+jaR7PJDDIoSOEcBTv381K+flfae05mVffBx4tGRiSo5EprV1WmGRbzH1o\nx6GksA1qy/H6HkMxnl2jLpFAE3vcRMjjJnW+1K8MToXe8dxUrZcYQ8Eaye0F8kpG\njr32hQEWynaRVArtnZpxq7m5lQpljA8AHCs+8hZ2CdqUm1v3HtmlOG99cCD2DX3r\ni3KQQL36jm81MaV1nml4std6nm6aLe8GQowUM7DZ5M5CbRQdmZDvHNjVh10N/ap4\n7Rm97D5LAgMBAAECggEAXtgPGyduP8/6sK4dExj2ENel/FDyelG6UvoCk6UQFGgx\nUgOufB/pTalvffndY3lMB0M2vNnwrnW2mGE+noopEtjIkayW7UyKvRqyN3bv4Cuj\neafSuvA4GBvociKdwD5iwrXbLUcy73wDBvL3638FIrxn032TymHLTZe/vrf3fb5p\n0MLUMfdH1NlARPZkE5m2Y1jo0LNbB+Wpv82X1nlUkupPOKJshAyi9kNfPv086oHl\nRVhYLX1tFDR/xCgYd5ah/jQ5zeO5dd3DkjijhIoE3Y8888KlxbpKNTpSEuhYe9fu\nV8/cA8IF+wrR2Z/Zgmy1gB+4PlAUE5UyVLzcY+TJuQKBgQDq7s7WQvSavcVHL9c6\n9Ar9eudIiTYBf0kGSAt+Xn1U1AcTZ3/5r2ts8u3rwO9emc/TcQ1+z1m9OBVzFTH1\nb/nwkpXrClL37dMW0ACjsRexDRtui161Zx7yCvBDhxz2gw5YfKVepN0Ae9J2dBZm\nvzmABAf4CjtCmCTeHnSXpqyVQwKBgQDqghBcYC+au+Ag1ZMaSxytWCS9gy1zlToE\nvpu3AJh5tup97V6CarGgOH2lZBczNc+VaRAa1jGRHciwlI6L2/04Do9jzw4CbAQO\niOcTMugjtwNcvwv3FiRiwkg6W1+Umj8OZYCV2tEr6AU+YtBPUM2lbFqOJEeOr5ud\nQf4TVa+eWQKBgQCCfAEFoEqbZ6uazkeMxt8Typ+K+iq0yi2U/47isTiLVPhZHrNF\nytivun3K424P7P4xQilstV3yaqP/N1Z4K6l2pPP/h8xtR/pmQUEZqdKu08jYrS/9\nMTlO1iR8XR8JC+F75D81Qfw9uIg8ol2O08bsA1EpwwUHB9nyRJgdYsWYYQKBgQCp\nlKSAKI5ENtg85jUaLnbuY28uHE4h5yethqjUDXo1ijDIH37YkI8ibbdugpLEVYVn\nZjJfNcViS0d1afgq60qR3vWSF4jp93J3kEiJeaalLRMhXoYoh7qIMDZK/QiBTYmL\nv5rcwv+/4GjqVEqPEL+lgFV7tICKjjLZ5X72PGBjAQKBgFPjqwkRynEdiIg2mFU6\nImsdQZ1SP8q8KvfnvR4T5yKeF5/OZgLREeBPpXXPh+8dhuMRR/j5JouR7vwyY+Fr\nSQTa2I3b4lSnqbGhnRh586MRrl/N+VKKbTPgtj9WLbHh4e4Hj0yXh8lpsk7rajAz\nGHvweiRp++kxn/0PqgPBkZuK\n-----END PRIVATE KEY-----\n",
//       "client_email": "firebase-adminsdk-1bqxz@followapp-16669.iam.gserviceaccount.com",
//       "client_id": "112532822243609327606",
//       "auth_uri": "https://accounts.google.com/o/oauth2/auth",
//       "token_uri": "https://oauth2.googleapis.com/token",
//       "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
//       "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-1bqxz%40followapp-16669.iam.gserviceaccount.com",
//       "universe_domain": "googleapis.com"
//     }
//   }).then((currentToken) => {
//     if (currentToken) {
//       console.log("USER_ID_HERE", currentToken);
//     }
//   });
axios.defaults.baseURL = baseURL;

// Default Key Join In Axios
axios.defaults.headers.common["key"] = secretKey;

axios.interceptors.request.use(
  (req) => {
    store.dispatch({ type: LOADER_OPEN, payload: req.url });
    return req;
  },
  (error) => {
    console.log(error);
  },
);

axios.interceptors.response.use(
  (res) => {
    store.dispatch({ type: CLOSE_LOADER });
    return res;
  },
  (err) => {
    if (err.message === "Network Error") {
    }
    store.dispatch({ type: CLOSE_LOADER });
    return Promise.reject(err);
  },
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={store}>
      <App />
      <ToastContainer style={{ zIndex: "99999999" }} />
      <Loader />
    </Provider>
  </BrowserRouter>,
  // </React.StrictMode>
);

reportWebVitals();
